/**
 * O seletor de período — um grupo, e não três links soltos.
 *
 * Nos prints da validação os filtros apareciam como texto avulso com um deles
 * pintado: nada dizia que eram alternativas entre si. Um trilho com fundo
 * próprio e a opção ativa em relevo resolve isso sem pedir mais espaço.
 */
import { cn } from '@/lib/utils'

interface Opcao<T> {
  valor: T
  rotulo: string
}

interface Props<T extends string | number> {
  opcoes: readonly Opcao<T>[]
  valor: T
  aoEscolher: (valor: T) => void
  /** O que o grupo escolhe, para quem navega por leitor de tela. */
  rotulo: string
}

export function FaixaDePeriodo<T extends string | number>({
  opcoes,
  valor,
  aoEscolher,
  rotulo,
}: Props<T>) {
  return (
    <div
      role="tablist"
      aria-label={rotulo}
      className="inline-flex rounded-lg border border-gray-800/70 bg-black/20 p-0.5"
    >
      {opcoes.map((opcao) => {
        const ativa = opcao.valor === valor
        return (
          <button
            key={String(opcao.valor)}
            type="button"
            role="tab"
            aria-selected={ativa}
            onClick={() => aoEscolher(opcao.valor)}
            className={cn(
              'rounded-md px-3 py-1.5 text-sm transition-colors',
              'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500/60',
              ativa
                ? 'bg-indigo-500/20 text-indigo-200 shadow-sm'
                : 'text-gray-400 hover:text-gray-200'
            )}
          >
            {opcao.rotulo}
          </button>
        )
      })}
    </div>
  )
}
